import { useOutletContext } from 'react-router-dom';
import ICS2ArrivalNotificationForm from 'views/declarations/eu/ics2/ICS2ArrivalNotificationForm';
import DeclarationFormContent from 'views/declarations/declaration-tabs/declaration-form/DeclarationFormContent';
import { ArrivalNotificationOutletContext } from './ArrivalNotificationPage';

/**
 * The cards of the arrival, beside the section navigation.
 *
 * `DeclarationFormContent` decides on its own whether to show the navigation by matching the
 * pathname against the declaration and manifest routes, which this page is not one of, so it is
 * told to. The id names the wrapper its scroll handler looks for to follow the section in view.
 */
const ArrivalNotificationFormTab = () => {
    const { formik, isEditable } = useOutletContext<ArrivalNotificationOutletContext>();

    return (
        <DeclarationFormContent showNavigation contentId="arrival-notification-main-content">
            <ICS2ArrivalNotificationForm formik={formik} viewOnly={!isEditable} />
        </DeclarationFormContent>
    );
};

export default ArrivalNotificationFormTab;
